module.exports = __webpack_public_path__ + "static/media/87gal16.9e51faa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/87gal/87gal16.jpg
// module id = 193
// module chunks = 0